<template>
  <div class="flexible-content">
    <!-- Sidebar -->
    <div class="sidebar-fixed position-fixed">
      <a class="logo-wrapper">
        <img alt src="../assets/Exsellance_Logo.png" class="ex-logo img-fluid" />
      </a>

      <mdb-list-group class="list-group-flush">
        <router-link to="/admin/dashboard" @click.native="activeItem = 1">
          <mdb-list-group-item :action="true" :class="activeItem === 1 && 'active'">
            <mdb-icon icon="chart-pie" class="mr-3" />Dashboard
          </mdb-list-group-item>
        </router-link>
        <router-link to="/admin/profiles" @click.native="activeItem = 2">
          <mdb-list-group-item :action="true" :class="activeItem === 2 && 'active'">
            <mdb-icon icon="user" class="mr-3" />Profiles
          </mdb-list-group-item>
        </router-link>
        <router-link to="/admin/videos" @click.native="activeItem = 3">
          <mdb-list-group-item :action="true" :class="activeItem === 3 && 'active'">
            <mdb-icon icon="file-video" class="mr-3" />Videos
          </mdb-list-group-item>
        </router-link>
        <router-link to="/admin/courses" @click.native="activeItem = 4">
          <mdb-list-group-item :action="true" :class="activeItem === 4 && 'active'">
            <mdb-icon icon="chalkboard-teacher" class="mr-3" />Courses
          </mdb-list-group-item>
        </router-link>
        <router-link to="/admin/podcasts" @click.native="activeItem = 5">
          <mdb-list-group-item :action="true" :class="activeItem === 5 && 'active'">
            <mdb-icon icon="chalkboard-teacher" class="mr-3" />Podcasts
          </mdb-list-group-item>
        </router-link>
        <router-link to="/admin/excelassessments" @click.native="activeItem = 6">
          <mdb-list-group-item :action="true" :class="activeItem === 6 && 'active'">
            <mdb-icon icon="chalkboard-teacher" class="mr-3" />Assessments (Excel)
          </mdb-list-group-item>
        </router-link>
      </mdb-list-group>
    </div>
    <!-- /Sidebar  -->
    <main>
      <div class="p-5">
        <router-view></router-view>
      </div>
    </main>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbBtn,
  mdbIcon,
  mdbListGroup,
  mdbListGroupItem,
  mdbCardBody,
  mdbFooter,
  waves
} from "mdbvue";
import Dashboard from "../components/AdminDashboard";
import Profile from "../components/AdminProfile";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
export default {
  name: "AdminTemplate",
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBtn,
    mdbListGroup,
    mdbListGroupItem,
    mdbIcon,
    mdbCardBody,
    ftr: mdbFooter,
    Dashboard,
    Profile
  },
  data() {
    return {
      activeItem: 1
    };
  },
  created() {},
  beforeMount() {
    console.log(this.$router);

    this.activeItem = 1;
    this.$router.replace("/admin/dashboard");

    //this.activeItem = this.$router.currentRoute.matched[0].props; //.props.page
  },
  mixins: [waves]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
main,
.flexible-content {
  background-color: #f2f6f7;
  min-height: 100vh;
}
.flexible-content {
  transition: padding-left 0.3s;
  padding-left: 270px;
}
.flexible-navbar {
  transition: padding-left 0.5s;
  padding-left: 270px;
}
.sidebar-fixed {
  left: 0;
  top: 0;
  height: 100vh;
  width: 270px;
  /* box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12); */
  z-index: 1050;
  background-color: #fff;
  padding: 1.5rem;
  padding-top: 0;
}
.sidebar-fixed .logo-wrapper img {
  width: 100%;
  padding: 2.5rem;
}
.sidebar-fixed .list-group-item {
  display: block !important;
  transition: background-color 0.3s;
}
.sidebar-fixed .list-group .active {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  background-color: #5542fb;
}

.list-group-item-action:hover {
}
@media (max-width: 1199.98px) {
  .sidebar-fixed {
    display: none;
  }
  .flexible-content {
    padding-left: 0;
  }
  .flexible-navbar {
    padding-left: 10px;
  }
}
</style>
<style>
.navbar-light .navbar-brand {
  margin-left: 15px;
  color: #2196f3 !important;
  font-weight: bolder;
}
</style>
